import React, { useCallback, useEffect, useState } from "react";
import { Avatar, Box, Flex, Group, Paper, Stack, Text } from "@mantine/core";
import { IconUpload, IconX } from "@tabler/icons-react";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { rem } from "@mantine/core";
import { useTranslation } from "react-i18next";
import FileSize from "./FileSize";

function FileUploaderSimple({ type, onFileSelected }) {
  const [isUploading, setIsUploading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const { t } = useTranslation("imports");

  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFile(acceptedFiles[0]);
    onFileSelected(acceptedFiles[0]);
    console.log("Selected file:", acceptedFiles[0]);
  });

  useEffect(() => {
    setSelectedFile(null);
    onFileSelected(null);
  }, [type]);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Dropzone
        onDrop={onDrop}
        multiple={false}
        onReject={(files) => console.log("rejected files", files)}
        maxSize={2 * 1024 ** 2}
        accept={
          type === "asin"
            ? [MIME_TYPES.xlsx]
            : [MIME_TYPES.csv, MIME_TYPES.xlsx]
        }
        loading={isUploading}
      >
        <Flex
          m="md"
          align="center"
          justify="center"
          mih={60}
          style={{ pointerEvents: "none" }}
        >
          <Dropzone.Accept>
            <Avatar
              size="xl"
              color="white"
              style={{ position: "absolute", zIndex: 22 }}
            >
              <IconUpload size={55} stroke={1.8} />
            </Avatar>
          </Dropzone.Accept>
          <Dropzone.Reject component="div">
            <Avatar
              size="xl"
              color="white"
              style={{ position: "absolute", zIndex: 22 }}
            >
              <IconX
                style={{
                  width: rem(52),
                  height: rem(52),
                  color: "var(--mantine-color-red-6)",
                }}
                stroke={1.8}
              />
            </Avatar>
          </Dropzone.Reject>
          <Group justify="center" gap="md" align="center">
            <IconUpload size={38} stroke={1.5} />
            <Stack align="center" gap={2}>
              <Text ta="center" size="lg" fw={500}>
                {t("upload.dropTitle")}
              </Text>
              {type === "asin" ? (
                <Text c="dimmed">{t("upload.dropHintXlsx")}</Text>
              ) : (
                <Text c="dimmed">{t("upload.dropHintCsvXlsx")}</Text>
              )}
            </Stack>
          </Group>
        </Flex>
      </Dropzone>
      {selectedFile ? (
        <Paper my="md" p="md" withBorder>
          <Text size="lg" mb="md">
            {selectedFile.name}
          </Text>
          <FileSize size={selectedFile.size} />
          <Text size="sm" c="dimmed">
            {selectedFile.type}
          </Text>
        </Paper>
      ) : null}
    </div>
  );
}

export default FileUploaderSimple;
